module.exports = "/_next/static/images/Valeria_Lozovanu-1a407fd5272448d83ac91152f742b48e.webp";